/* eslint-disable camelcase */
import accepted from '../../assets/handSignals/accepted.png';
import contest from '../../assets/handSignals/contest.png';
import disc_down from '../../assets/handSignals/disc_down.png';
import disc_up from '../../assets/handSignals/disc_up.png';
import foul from '../../assets/handSignals/foul.png';
import gender_ratio_men from '../../assets/handSignals/gender_ratio_men.png';
import gender_ratio_women from '../../assets/handSignals/gender_ratio_women.png';
import goal from '../../assets/handSignals/goal.png';
import in_out from '../../assets/handSignals/in_out.png';
import marking_infraction from '../../assets/handSignals/marking_infraction.png';
import match_point from '../../assets/handSignals/match_point.png';
import offside from '../../assets/handSignals/offside.png';
import pick from '../../assets/handSignals/pick.png';
import play_has_stopped from '../../assets/handSignals/play_has_stopped.png';
import retracted from '../../assets/handSignals/retracted.png';
import spirit_stoppage from '../../assets/handSignals/spirit_stoppage.png';
import stoppage from '../../assets/handSignals/stoppage.png';
import timeOut from '../../assets/handSignals/time-out.png';
import timing_violation from '../../assets/handSignals/timing_violation.png';
import travel from '../../assets/handSignals/travel.png';
import turnover from '../../assets/handSignals/turnover.png';
import violation from '../../assets/handSignals/violation.png';
import who_made_the_call from '../../assets/handSignals/who_made_the_call.png';

import { Levels, Categories } from '../../src/utils/config';

export default [
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: accepted,
    answerChoices: {
      a: 'Accepted',
      b: 'Retracted',
      c: 'Marking infraction',
      d: 'I need to think',
    },
    correctAnswers: ['a'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: contest,
    answerChoices: {
      a: 'Contest',
      b: 'Marking infraction',
      c: 'Foul',
      d: 'Turnover',
    },
    correctAnswers: ['a'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: disc_down,
    answerChoices: {
      a: 'Turnover',
      b: 'Disc Down',
      c: 'Travel',
      d: 'Point',
    },
    correctAnswers: ['b'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: disc_up,
    answerChoices: {
      a: 'Who made the call',
      b: 'Disc Up',
      c: 'Point',
      d: 'Stoppage',
    },
    correctAnswers: ['b'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: foul,
    answerChoices: {
      a: 'Contest',
      b: 'Offside',
      c: 'Foul',
      d: 'Pick',
    },
    correctAnswers: ['c'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: gender_ratio_men,
    answerChoices: {
      a: 'Gender ratio FMP (Female Matching Player)',
      b: 'Stoppage',
      c: 'Gender ratio MMP (Male Matching Player)',
      d: 'Pick',
    },
    correctAnswers: ['c'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.MIDDLE,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: gender_ratio_women,
    answerChoices: {
      a: 'Marking infraction',
      b: 'Stoppage',
      c: 'Gender ratio MMP (Male Matching Player)',
      d: 'Gender ratio FMP (Female Matching Player)',
    },
    correctAnswers: ['d'],
    explanation: 'Attention, the only difference with the mark infraction gesture is: the hands are closed fists.',
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.DIFFICULT,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: goal,
    answerChoices: {
      a: 'Match point',
      b: 'Violation',
      c: 'Pick',
      d: 'Point',
    },
    correctAnswers: ['d'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: in_out,
    answerChoices: {
      a: 'In or Out',
      b: 'Who made the call',
      c: 'Marking infraction',
      d: 'Turnover',
    },
    correctAnswers: ['a'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: marking_infraction,
    answerChoices: {
      a: 'Marking infraction',
      b: 'Violation',
      c: 'Gender ratio FMP (Female Matching Player)',
      d: 'Stall-out',
    },
    correctAnswers: ['a'],
    explanation:
      'Attention, the only difference with the gesture of gender ratio FMP (Female Matching Player) is: the hands are open facing up.',
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.MIDDLE,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: match_point,
    answerChoices: {
      a: 'Foul',
      b: 'Match Point',
      c: 'Offside',
      d: 'Stall-Out',
    },
    correctAnswers: ['b'],
    explanation: 'This is often referred to as the universe, or double game point.',
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.MIDDLE,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: offside,
    answerChoices: {
      a: 'Foul',
      b: 'Offside',
      c: 'Turnover',
      d: 'Contest',
    },
    correctAnswers: ['b'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: pick,
    answerChoices: {
      a: 'Violation',
      b: 'Point',
      c: 'Pick',
      d: 'Marking infraction',
    },
    correctAnswers: ['c'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: play_has_stopped,
    answerChoices: {
      a: 'Travel',
      b: 'Violation',
      c: 'The game is stopped',
      d: 'Who made the call',
    },
    correctAnswers: ['c'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.MIDDLE,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: retracted,
    answerChoices: {
      a: 'Foul',
      b: 'Travel',
      c: 'Accepted',
      d: 'Retracted',
    },
    correctAnswers: ['d'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: spirit_stoppage,
    answerChoices: {
      a: 'Time-out',
      b: 'Travel',
      c: 'Foul',
      d: 'Spirit Stoppage',
    },
    correctAnswers: ['d'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: stoppage,
    answerChoices: {
      a: 'Stoppage',
      b: 'Gender ratio FMP (Female Matching Player)',
      c: 'Gender ratio MMP (Male Matching Player)',
      d: 'Stall-Out',
    },
    correctAnswers: ['a'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.MIDDLE,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: timeOut,
    answerChoices: {
      a: 'Time-out',
      b: 'Foul',
      c: 'Spirit stop',
      d: 'Travel',
    },
    correctAnswers: ['a'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: timing_violation,
    answerChoices: {
      a: 'Offside',
      b: 'Stall-Out',
      c: 'Stoppage',
      d: 'Pick',
    },
    correctAnswers: ['b'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: travel,
    answerChoices: {
      a: 'Retracted',
      b: 'Travel',
      c: 'Accepted',
      d: 'Pick',
    },
    correctAnswers: ['b'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: turnover,
    answerChoices: {
      a: 'Disc up',
      b: 'Contest',
      c: 'Turnover',
      d: 'Disc down',
    },
    correctAnswers: ['c'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: violation,
    answerChoices: {
      a: 'Point',
      b: 'Offside',
      c: 'Violation',
      d: 'Pick',
    },
    correctAnswers: ['c'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.EASY,
  },
  {
    category: Categories.HAND_SIGNALS,
    question: 'What does this gesture mean?',
    image: who_made_the_call,
    answerChoices: {
      a: 'In or Out',
      b: 'Foul',
      c: 'Point',
      d: 'Who made the call',
    },
    correctAnswers: ['d'],
    explanation: '',
    rules: undefined,
    source: 'Hand Signals - Raphy Candelier',
    level: Levels.MIDDLE,
  },
];
